import axios from "axios"
import { getUsuario } from "utils/DatosUsuarioLocalStorag"

/* Canales de venta por localidad y venta por personal sin comisiones (backend MS-LOGIN-BOLETERIA,
   VentaPersonal.controller.js). Las apps no cambian: el backend les entrega los valores ya ajustados. */

const BASE = "https://api.t-ickets.com/ms_login/api/v1/venta_personal"
const headers = () => ({
    "Content-Type": "application/json",
    "authorization-ticket": "Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==",
    "Authorization": `Bearer ${getUsuario()}`,
})

// { migracion, config: { sin_comision_boleto, sin_comision_metodo, sin_iva }, localidades: [{ localidad, venta_publica, venta_personal, ... }] }
export const ObtenerVentaPersonalEvento = async (codigoEvento) =>
    (await axios.get(`${BASE}/evento`, { headers: headers(), params: { codigoEvento } })).data
export const GuardarVentaPersonalEvento = async (codigoEvento, config) =>
    (await axios.post(`${BASE}/evento`, { codigoEvento, ...config }, { headers: headers() })).data
export const GuardarCanalLocalidad = async (codigoEvento, localidad, venta_publica, venta_personal) =>
    (await axios.post(`${BASE}/localidad`, { codigoEvento, localidad, venta_publica, venta_personal }, { headers: headers() })).data
// Localidad solo para algunos usuarios (usuarios = [] la deja para todos)
export const GuardarUsuariosLocalidad = async (codigoEvento, localidad, usuarios) =>
    (await axios.post(`${BASE}/localidad_usuarios`, { codigoEvento, localidad, usuarios }, { headers: headers() })).data
export const UsuariosSinComisiones = async () => (await axios.get(`${BASE}/usuarios`, { headers: headers() })).data
export const GuardarUsuarioSinComisiones = async (id_usuario, sin_comisiones) =>
    (await axios.post(`${BASE}/usuario`, { id_usuario, sin_comisiones }, { headers: headers() })).data

// Al vender en esta pagina: con sesion de personal (panel) solo las localidades de "App de venta y panel";
// sin sesion (tienda publica) solo las de "Pagina y app normal". El backend ya filtra al publico.
// venta_usuario = 0: la localidad es solo para otros usuarios (lo calcula el backend con la sesion).
export const filtrarLocalidadesPorCanal = (lista) => {
    const personal = typeof getUsuario() === "string" && getUsuario().length > 0
    return (Array.isArray(lista) ? lista : []).filter((p) =>
        Number((personal ? p?.venta_personal : p?.venta_publica) ?? 1) !== 0 && Number(p?.venta_usuario ?? 1) !== 0)
}
